import { render, staticRenderFns } from "./CategoriesCRUD.vue?vue&type=template&id=31c91a36&"
import script from "./CategoriesCRUD.vue?vue&type=script&lang=js&"
export * from "./CategoriesCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports